import Enfinity from "@/assets/images/enfinity-microsoft.png";
import Logo from "@/assets/svg/full-logo/adcelerate-blue.svg";
import scrollTo from "@/utils/scrollTo";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function AdceFooter() {
  const navigate = useNavigate();
  const location = useLocation();

  const goUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleScrollTo = (targetPath, scrollId) => {
    if (location.pathname === targetPath) {
      scrollTo(scrollId);
    } else {
      navigate(targetPath, { state: { scrollTo: scrollId } });
    }
  };

  return (
    <div className="bg-white p-16">
      <div className="flex flex-col justify-center items-center gap-12">
        <img src={Logo} alt="Adcelerate Logo" />
        <div className="flex flex-col lg:flex-row items-center justify-center gap-6 lg:gap-20 text-[#223679] text-lg">
          {location.pathname === "/" ? (
            <p
              className={`cursor-pointer hover:underline ${
                location.pathname === "/"
              }`}
              onClick={() => goUp()}
            >
              Home
            </p>
          ) : (
            <Link to="/" className="block">
              <p className="cursor-pointer hover:underline">Home</p>
            </Link>
          )}
          {location.pathname === "/about-us" ? (
            <p
              className={`cursor-pointer hover:underline ${
                location.pathname === "/about-us"
              }`}
              onClick={() => goUp()}
            >
              About us
            </p>
          ) : (
            <Link to="/about-us" className="block">
              <p className="cursor-pointer hover:underline">About us</p>
            </Link>
          )}
          {location.pathname === "/testimonials" ? (
            <p
              className={`cursor-pointer hover:underline ${
                location.pathname === "/testimonials"
              }`}
              onClick={() => goUp()}
            >
              Testimonials
            </p>
          ) : (
            <Link to="/testimonials" className="block">
              <p className="cursor-pointer hover:underline">Testimonials</p>
            </Link>
          )}
          <p
            className="cursor-pointer hover:underline"
            onClick={() => handleScrollTo("/", "features")}
          >
            Features
          </p>
          <p
            className="cursor-pointer hover:underline"
            onClick={() => handleScrollTo("/", "how-it-works")}
          >
            How it works
          </p>
          <p
            className="cursor-pointer hover:underline"
            onClick={() => handleScrollTo("/", "partners")}
          >
            Partners
          </p>
        </div>
        <a
          href="https://support.microsoft.com/en-us/topic/msn-content-provider-partner-directory-ddbc2fb3-2693-4717-88a0-7713122c8026"
          target="_blank"
        >
          <img src={Enfinity} className="max-w-60" alt="Enfinity" />
        </a>
        {/* {location.pathname === "/" && (
          <div className="flex gap-3 items-center justify-end hero-reveal">
            <img
              src={Youtube}
              className="w-14 md:w-14 h-14 md:h-14"
              alt="YouTube"
            />
            <div className="border-l-2 border-gray-400 h-12 hidden md:block"></div>
            <div className=" text-blck md:pl-2 text-left">
              <p className="flex gap-2 text-nowrap">
                Official YouTube Certified
                <img src={BadgeCheck} alt="Badge" />
              </p>
              <p>Creator Service Provider</p>
            </div>
          </div>
        )} */}
        <p className="text-gray-500 text-center">
          © Adcelerate 2025 | by Enfinity Limited
        </p>
      </div>
    </div>
  );
}
